/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';

// ---------------------------------------------------------------------------
// "Esta conta consegue emitir?" — deriva de `has_active_credential` (adendo do
// handoff 0079). Serve para o operador ver na LISTA o que antes só descobria
// abrindo a ficha (ou, pior, no 422 do submit da cobrança).
//
// Campo ausente (front à frente do backend) → não afirma nada: mostra um traço
// neutro em vez de acusar falsamente uma conta de não emitir.
// ---------------------------------------------------------------------------

export default function IssuanceBadge({ value }) {
   if (value === undefined || value === null) {
      return <StatusBadge variant="neutral">—</StatusBadge>;
   }
   return (
      <StatusBadge variant={value ? 'green' : 'amber'}>
         {value ? 'Apta' : 'Sem chave ativa'}
      </StatusBadge>
   );
}

IssuanceBadge.propTypes = {
   value: PropTypes.bool,
};
